import React,{useState,useEffect} from 'react'
import { sellersList,sellersCategories } from 'network/ApiAxiosTickets'
import { Container, Row, Button, Col,Modal, ModalHeader, ModalBody } from "reactstrap";
import SellerPermissionCard from './SellerPermissionCard';
import AddNewSellerDropdown from './AddNewSellerDropdown';
import Header from 'components/Headers/Header';
import { killAllSellers } from 'network/ApiAxiosTickets';
import { getAll } from 'network/ApiAxiosEventsGetickets';
import { allSellersList } from 'network/ApiAxiosTickets';

function SellerPermissions() {
    const [sellers, setSellers] = useState('');
    const [categories, setCategories] = useState('');
    const [modal, setModal] = useState(false);
    const [killState, setKillState] = useState(null);

    const toggle = () => setModal(!modal);
    const role = JSON.parse(localStorage.getItem("user")).role

    useEffect(() => {
        getSellers()
        getCategories()
        checkKillAllState()
    }, []);

    const getSellers = async()=>{
        const resp = await allSellersList()
        if(resp.data.success){
            setSellers(resp.data.sellers)
        }
    }

    const getCategories = async()=>{
        const resp = await getAll('all')
        //const resp = await sellersCategories()
        if(resp.data.success){
            console.log('main events----',resp.data.records)
            setCategories(resp.data.records)
        }
    }

    const handleKillAll = async()=>{
        const resp = await killAllSellers()
        if(resp.data.success){
            setKillState(!killState)
        }
    }

    const checkKillAllState = async()=>{
        const resp = await killAllSellers('check')
        if(resp.data.success){
            setKillState(resp.data.state)
        }
    }
   
  return (
    <>
    {role=="admin" && <Header/>}
    <Container  className="w-auto" fluid>
        <Row className="mt--4 mb-4">
            <Col xl="2" xs="4" className="mt-7" >
                
            </Col>
            <Col xl="6" xs="4">
                <Button onClick={handleKillAll} disabled={killState==null?true:false} className={killState ? 'btn-danger' : 'bg-green'} >{killState ? 'Start' : 'Stop'} All Sellers</Button>
            </Col>
            <Col xl="4" xs="4" className="mt-7">
                <Button onClick={toggle}><i className='ni ni-fat-add mr-1' /> Add Seller </Button>
            </Col>
        </Row>

        <Row>
            {sellers ? sellers.map((seller)=>{
                return <Col key={seller._id} className='mb-2 d-flex justify-content-center' >
                            <SellerPermissionCard seller={seller} categories={categories} key={seller._id}/>
                        </Col>
            }) : null}
        </Row>
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader>
                Add New Seller
            </ModalHeader>
            <ModalBody >
                <Row className=' justify-content-center'>
                    <AddNewSellerDropdown toggle={toggle}/>
                </Row>
            </ModalBody>
        </Modal>
    </Container>
    </>
  )
}

export default SellerPermissions